module.exports = __webpack_public_path__ + "static/media/Book.5ad9fe44.svg";